import { LegalLayout } from "./components/legalLayout";
import { TERMS_OF_USE } from "./content/termsOfUse";

/** /termos-de-uso — também servida em /terms-of-use, com canonical aqui. */
export const TermosDeUso = () => <LegalLayout document={TERMS_OF_USE} />;
